module.exports = __webpack_public_path__ + "img/keep.e18bbd90.png";